import React from "react";
import { Table } from "antd";
import { TICKET_DETAILS_WIDTHS } from "../../../../../constants/tableWidths";

const ExpandedTicketRow = ({ record, loading }) => {
  const childColumns = [
    {
      title: window.screen.width > 500 ? "Purchaser Name" : "Name",
      width: TICKET_DETAILS_WIDTHS.PURCHASER_NAME,
      className: "header-white",
      key: "name",
      align: "center",
    },
    {
      title: "Ticket",
      width: TICKET_DETAILS_WIDTHS.TICKET,
      className: "header-white",
      key: "ticketName",
      dataIndex: "ticketName",
      align: "center",
    },
    {
      width: TICKET_DETAILS_WIDTHS.QUANTITY,
      title: "Quantity",
      key: "quantity",
      className: "header-white",
      align: "center",
      dataIndex: "quantity",
    },
    {
      width: TICKET_DETAILS_WIDTHS.CHECKED_IN,
      title: "Checked-in",
      key: "checkedin",
      className: "header-white",
      align: "center",
      dataIndex: "checkedin",
    },
    {
      width: TICKET_DETAILS_WIDTHS.REVENUE,
      title: "Revenue",
      key: "revenue",
      className: "header-white",
      align: "center",
    },
    {
      title: "Purchase Date",
      align: "center",
      className: "header-white",
      width: TICKET_DETAILS_WIDTHS.PURCHASE_DATE,
      key: "purchasedDate",
    },
    {
      title: "Purchase Date",
      align: "center",
      className: "header-white",
      width: TICKET_DETAILS_WIDTHS.PURCHASE_TIME,
      key: "purchasedDate",
    },
    {
      title: window.screen.width > 500 ? "Purchaser Email" : "Email",
      width: TICKET_DETAILS_WIDTHS.PURCHASER_EMAIL,
      className: "header-white",
      align: "center",
      key: "email",
    },
    {
      title: "Attendee(s)",
      align: "center",
      width: TICKET_DETAILS_WIDTHS.ATTENDEES,
      className: "header-white",
      key: "attendees",
      dataIndex: "attendees",
      render: (data) => {
        return (
          <div>
            {data?.map((item, index) => {
              return (
                <p
                  key={index}
                  style={{ fontSize: "12px" }}
                >{`${index + 1}. ${item.fullName || "-"} ${item.email || ""}`}</p>
              );
            })}
          </div>
        );
      },
    },
  ];

  const data = Object.values(record.purchasedSubTickets || {}).map((item) => {
    return {
      ticketName: item.name,
      quantity: item.ticketBought,
      checkedin: "",
      attendees: item.attendees || [],
    };
  });

  return (
    <Table
      rowKey="id"
      key="id"
      columns={childColumns}
      dataSource={data}
      showHeader={false}
      pagination={false}
      loading={loading}
      bodyStyle={{
        fontSize: window.screen.width > 500 ? "18px" : "12px",
        backgroundColor: "var(--primary-dashboard-background)",
      }}
    />
  );
};

export default ExpandedTicketRow;
